import { useCallback } from "react";
import { useApolloClient, useMutation } from "@apollo/client";

import { WORK_SESSION_LOG_SCAN } from "graphql/mutation/attendance-gql";
import { GET_WORK_SESSIONS } from "graphql/query/attendance-gql";


const useAttendanceMutationScan = () => {
    const client = useApolloClient();
    const [ scan, { loading, error } ] = useMutation(WORK_SESSION_LOG_SCAN);

    const attendanceScan = useCallback(async (input) => {
        try {
            return await scan({ variables: { input } });
        } finally {
            // A closed scanner can still have a mutation in flight. Refresh on settlement,
            // and keep refresh failures separate from the original scan result.
            Promise.resolve().then(() => client.refetchQueries({
                include: [ GET_WORK_SESSIONS ],
                updateCache: (cache) => {
                    cache.evict({ id: "ROOT_QUERY", fieldName: "workSessionsCursor" });
                    cache.gc();
                },
                onQueryUpdated: (observable) => {
                    observable.reobserve({
                        context: {
                            ...observable.options.context,
                            queryDeduplication: false
                        }
                    }).catch(() => undefined);

                    // The explicit reobserve owns this refresh; suppress the cache-watch one.
                    return false;
                }
            })).catch(() => undefined);
        }
    }, [ client, scan ]);

    return {
        attendanceScan,
        loading,
        error
    };
};

export default useAttendanceMutationScan;
